const type = 'SET_RECHARGE_EMAIL_SENT';

const setRechargeEmailSent = () => ({
  type,
});

export default setRechargeEmailSent;
